/**
 * Load constants such as industries list and countries list, etc.
 */

import { CURRENT_VERSION } from '../constants/config';
import { handleReponse } from './index.js';
import fetchAPI from 'utils/fetchAPI';

export const SAVE_INDUSTRIES = 'SAVE_INDUSTRIES';

const saveIndustries = ({ industries }) => ({
  type: SAVE_INDUSTRIES,
  industries,
});

export const SAVE_COUNTRIES = 'SAVE_COUNTRIES';

function saveCountries({ countries }) {
  return {
    type: SAVE_COUNTRIES,
    countries,
  };
}

export const SAVE_CURRENCIES = 'SAVE_CURRENCIES';

function saveCurrencies({ currencies }) {
  return {
    type: SAVE_CURRENCIES,
    currencies,
  };
}

export const SAVE_UNITS = 'SAVE_UNITS';

function saveUnits({ units }) {
  return {
    type: SAVE_UNITS,
    units,
  };
}

export const SAVE_TRADE_TERMS = 'SAVE_TRADE_TERMS';

function saveTradeTerms({ terms }) {
  return {
    type: SAVE_TRADE_TERMS,
    terms,
  };
}

export const getIndustries = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/companies/industry-types',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => handleReponse(res, dispatch))
      .then(json =>
        dispatch(
          saveIndustries({
            industries: json.data,
          })
        )
      );
  });

const shouldFetchIndustries = state =>
  state.constants.industries.length === 0 ||
  state.app.version !== CURRENT_VERSION;

export const fetchIndustriesIfNeeded = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    if (shouldFetchIndustries(getState())) {
      dispatch(getIndustries());
    }
  });

export function fetchCurrencies() {
  return (dispatcher, getState) =>
    new Promise((resolve, reject) => {
      require(['../constants/currency.json'], currencies => {
        dispatcher(
          saveCurrencies({
            currencies,
          })
        );
        resolve(currencies);
      });
    });
}

export function fetchCountries() {
  return (dispatcher, getState) =>
    new Promise((resolve, reject) => {
      require(['../constants/names.json'], countries => {
        dispatcher(
          saveCountries({
            countries,
          })
        );
        resolve(countries);
      });
    });
}

const shouldFetchCountries = state =>
  Object.keys(state.constants.countries).length === 0 ||
  state.app.version !== CURRENT_VERSION;

export const fetchCountriesIfNeeded = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    if (shouldFetchCountries(getState())) {
      dispatch(fetchCountries());
    }
  });

export function fetchUnits() {
  /**
   * TODO: fetch translations if needed, then read off units.
   * TODO: centralize it. cos this returns a lot of other things.
   */
  return (dispatcher, getState) =>
    new Promise((resolve, reject) => {
      fetchAPI({
        endpoint: '/trades/constants',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .then(constants => {
          dispatcher(
            saveUnits({
              units: constants.unit,
            })
          );
          resolve(constants.unit);
        });
    });
}

const shouldFetchUnits = state =>
  state.constants.units.length === 0 || state.app.version !== CURRENT_VERSION;

export const fetchUnitsIfNeeded = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    if (shouldFetchUnits(getState())) {
      dispatch(fetchUnits());
    }
  });

export function fetchTradeTerms() {
  /**
   * TODO: FETCH trades/constants if needed, if not exists.
   */
  return (dispatcher, getState) =>
    new Promise((resolve, reject) => {
      fetchAPI({
        endpoint: '/trades/constants',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .then(constants => {
          dispatcher(
            saveTradeTerms({
              terms: constants.trade_term,
            })
          );
          resolve(constants.trade_term);
        });
    });
}

const shouldFetchTradeTerms = state =>
  Object.keys(state.constants.tradeTerms).length === 0 ||
  state.app.version !== CURRENT_VERSION;

export const fetchTradeTermsIfNeeded = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    if (shouldFetchTradeTerms(getState())) {
      dispatch(fetchTradeTerms());
    }
  });



// WEBPACK FOOTER //
// ./app/actions/ConstantsActionCreators.js